import moment from "moment";
import { Applicant } from "types/application";
import { HugeiconsIcon, IconSvgElement } from "@hugeicons/react";
import { Mail01Icon } from "@hugeicons-pro/core-stroke-rounded";

interface EmailSentSectionProps {
  applicant: Applicant;
  emailSentAt?: string | Date;
}

export const EmailSentSection: React.FC<EmailSentSectionProps> = ({
  applicant,
  emailSentAt
}: EmailSentSectionProps) => {
  return (
    <div className="flex flex-col gap-2 justify-center items-center p-60">
      <div className=" bg-warning-50 p-6 rounded-full flex items-center justify-center">
        <HugeiconsIcon
          icon={Mail01Icon as IconSvgElement}
          className="text-warning-500"
          size="30"
        />
      </div>
      <h2 className="text-base font-bold text-center">
        Email with animal screening request has been sent
      </h2>
      <p className="text-center text-content-300 text-sm">
        {`Email has been sent to ${applicant.email}  ${emailSentAt ? "on " + moment(emailSentAt).format("MMM DD, YYYY [at] h:mm A") : ""}`}
      </p>
    </div>
  );
};
